import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import Loader from '../../components/loader';

import {
  fetchAddress,
} from '../../actions';

class DeleteAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleting: false,
    };
    this.toggleDeleting = this.toggleDeleting.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAddresses = this.handleAddresses.bind(this)
  }

  componentDidMount() {
    const { dispatch, automationDetails } = this.props;

    const useAsset = automationDetails.meta.depositAsset;

    const usePriority = automationDetails.priority.toString() || '';

    this.setState({newPriority: usePriority  });

    const data = {
      asset: useAsset,
    };

    dispatch(fetchAddress(data))
      .then((res) => {
        if (res.type === 'FETCH_ADDRESS_SUCCESS') {
          this.handleAddresses();
        }
      });
  }

  componentDidUpdate() {
  }

  handleAddresses() {
    const { dispatch, coins } = this.props;
    const { walletAddresses } = this.state;

    let useAddresses;

    if (coins && coins.length) {
      useAddresses = coins.filter((item) => {
        return item.autoBuy === true;
      });
    }

    this.setState({ automationAddresses: useAddresses, addressLoaded: true });
  }

  copyToClipboard(e) {
    this.depositaddress.select();
    document.execCommand('copy');
    e.target.focus();
  }

  toggleEditing() {
    const { isEditing } = this.state;
    const { automationDetails } = this.props;

    const usePriority = automationDetails.priority.toString() || '';

    this.setState({isEditing: !isEditing, newPriority: usePriority, pristine: true});
  }

  toggleDeleting() {
    const { isDeleting } = this.state;
    this.setState({isDeleting: !isDeleting, pristine: true});
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  render() {
    const { user, errors, success, assets } = this.props;
    const {
      automationDetails,
      handleDeleteAutomation,
    } = this.props;

    const { isDeleting, newPriority, pristine, addressLoaded, automationAddresses } = this.state;

    const buyLoop = automationDetails.meta && automationDetails.meta.assetsToBuy && automationDetails.meta.assetsToBuy.length && automationDetails.meta.assetsToBuy.map((buy, index) => {
      const key = `buy-${index}`;

      let assetName;

      if (assets && assets.length && buy.asset) {
        assetName = assets.find(e => e.handle === buy.asset);
      }

      if (assetName && assetName.name) {
        assetName = assetName.name;
      }

      return (
        <div key={key} className="flex-container align-middle" style={{marginBottom: 8}}>
          <div style={{
            marginRight: 32,
            color: '#2c40c3',
            fontWeight: 'bold'
          }}>
            {buy.percentage}%
          </div>
          <div className={`vlt-coin ${assetName.replace(/\s/g, "-").toLowerCase()}`}>
            <img alt={assetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${assetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
          </div>
          <div style={{marginLeft: 8}}>
            {buy.asset}
          </div>
        </div>
      );
    });

    let useAddress = '';

    if (automationAddresses && (automationAddresses.length || automationAddresses.address)) {
      useAddress = automationAddresses.address || automationAddresses[0].address;
    }

    const automationReference = automationDetails.referenceId || '';

    const editIsReady = newPriority && newPriority.length && (Number(newPriority) > 0) && !pristine;

    let assetName;

    if (assets && assets.length && automationDetails.meta.depositAsset) {
      assetName = assets.find(e => e.handle === automationDetails.meta.depositAsset);
    }

    if (assetName && assetName.name) {
      assetName = assetName.name;
    }

    if (!addressLoaded) {
      return (
        <div className="cell small-12 medium-12 large-12 automation-modal">
          <div className="modal-heading">
            Delete Automation
          </div>
          <div className="grid-x modal-body">
            <div className="center-loader" style={{ minHeight: 200, width: '100%' }}>
              <Loader logo dark />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cell small-12 medium-12 large-12 automation-modal">
        <div className="modal-heading">
          Delete Automation
        </div>
        <div>
          <b>Are you sure you want to delete this automation? This cannot be undone.</b>
        </div>
        <div className="grid-x modal-body">
          <div className="cell small-12 medium-12 large-12">
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 5}}>
                <b>Address:</b>
              </div>
              <div className="flex-container align-middle">
                {useAddress}
              </div>
            </div>
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 5}}>
                <b>When I deposit:</b>
              </div>
              <div className="flex-container align-middle">
                <div className={`vlt-coin ${assetName.replace(/\s/g, "-").toLowerCase()}`}>
                  <img alt={assetName} src={`${process.env.REACT_APP_CDN}/assets/icons/assets/${assetName.replace(/\s/g, "-").toLowerCase()}.svg`} />
                </div>
                <div style={{marginLeft: 8}}>
                  {automationDetails.meta.depositAsset || ''}
                </div>
              </div>
            </div>
            <hr />
            <div className="lr-p lr-p--top">
              <div style={{marginTop: 0}}>
                <b>I want to buy:</b>
              </div>
              <div>
                {buyLoop}
              </div>
            </div>
            <hr />
          </div>
        </div>
        <div className="cell small-12 medium-12 large-12 modal-actions">
          <button
            className="button"
            type="button"
            onClick={() => this.props.toggleModal(null)}>
            <span>
              Cancel
            </span>
          </button>
          <button
            className="vlt-button vlt-red"
            type="button"
            onClick={() => handleDeleteAutomation(automationReference)}>
            <span>
              Confirm Delete
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
  coins: state.coins.coins,
});

export default withRouter(connect(mapStateToProps)(DeleteAutomation));
